"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconSort', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M5.3895,0.07575 C5.5125,0.12675 5.6235,0.19975 5.7155,0.29275 L8.72125,3.286 C9.11225,3.677 9.11225,4.309 8.72125,4.7 C8.52625,4.895 8.27025,4.993 8.01425,4.993 C7.75825,4.993 7.50225,4.895 7.30725,4.7 L6.0075,3.41275 L6.0075,14.99875 C6.0075,15.55175 5.5605,15.99875 5.0075,15.99875 C4.4545,15.99875 4.0075,15.55175 4.0075,14.99875 L4.0075,3.41275 L2.70725,4.7 C2.24727075,5.091 1.68425,5.091 1.29325,4.7 C0.90225,4.309 0.90225,3.677 1.29325,3.286 L4.2995,0.29275 C4.3915,0.19975 4.5025,0.12675 4.6255,0.07575 C4.8695,-0.02525 5.1455,-0.02525 5.3895,0.07575 Z M11.007,2.10498285e-13 C11.56,2.10498285e-13 12.007,0.447 12.007,1 L12.007,12.586 L13.30725,11.29875 C13.7672292,10.90775 14.33025,10.90775 14.72125,11.29875 C15.11225,11.68975 15.11225,12.32175 14.72125,12.71275 L11.715,15.706 C11.623,15.799 11.512,15.872 11.389,15.923 C11.145,16.024 10.869,16.024 10.625,15.923 C10.502,15.872 10.391,15.799 10.299,15.706 L7.29325,12.71275 C6.90225,12.32175 6.90225,11.68975 7.29325,11.29875 C7.48825,11.10375 7.74425,11.00575 8.00025,11.00575 C8.25625,11.00575 8.51225,11.10375 8.70725,11.29875 L10.007,12.586 L10.007,1 C10.007,0.447 10.454,2.10498285e-13 11.007,2.10498285e-13 Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg',
    id: 'a'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M9.707,4.293 C10.098,4.684 10.098,5.316 9.707,5.707 C9.512,5.902 9.256,6 9,6 C8.744,6 8.488,5.902 8.293,5.707 L7,4.414 L7,18 C7,18.553 6.553,19 6,19 C5.447,19 5,18.553 5,18 L5,4.414 L3.707,5.707 C3.316,6.098 2.684,6.098 2.293,5.707 C1.902,5.316 1.902,4.684 2.293,4.293 L5.292,1.294 C5.384,1.201 5.495,1.128 5.618,1.077 C5.862,0.976 6.138,0.976 6.382,1.077 C6.505,1.128 6.616,1.201 6.708,1.294 L9.707,4.293 Z M17.707,14.293 C18.098,14.684 18.098,15.316 17.707,15.707 L14.708,18.706 C14.616,18.799 14.505,18.872 14.382,18.923 C14.26,18.974 14.13,19 14,19 C13.87,19 13.74,18.974 13.618,18.923 C13.495,18.872 13.384,18.799 13.292,18.706 L10.293,15.707 C9.902,15.316 9.902,14.684 10.293,14.293 C10.684,13.902 11.316,13.902 11.707,14.293 L13,15.586 L13,2 C13,1.447 13.447,1 14,1 C14.553,1 15,1.447 15,2 L15,15.586 L16.293,14.293 C16.684,13.902 17.316,13.902 17.707,14.293 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
}), _SVGIconWithSizes)));

exports.default = _default;